import { Box, Heading, Text } from "@chakra-ui/react";

interface SidebarBrandProps {
  isCollapsed?: boolean;
}

const SidebarBrand = ({ isCollapsed = false }: SidebarBrandProps) => {
  if (isCollapsed) {
    return null;
  }

  return (
    <Box px={4} textAlign="left">
      <Heading size="md" color="brand.700" _dark={{ color: "brand.300" }}>
        Wellprept
      </Heading>
      <Text fontSize="sm" color="gray.500" _dark={{ color: "gray.400" }}>
        Admin Panel
      </Text>
    </Box>
  );
};

export default SidebarBrand; 